import {Box, HStack, Icon, Radio, RadioGroup, Text, VStack} from "@chakra-ui/react";
import {FiEye, FiEyeOff, FiUsers} from "react-icons/fi";
import {BookingVisibility} from "../services/responses";

export const BOOKING_VISIBILITIES: {
  value: BookingVisibility,
  label: string,
  hint: string,
  icon: typeof FiUsers,
}[] = [
  {
    value: 'public',
    label: 'Public',
    hint: 'Everyone sees who booked an item.',
    icon: FiUsers,
  },
  {
    value: 'owner',
    label: 'Visible to me only',
    hint: 'You see who booked; other guests only see that an item is taken.',
    icon: FiEye,
  },
  {
    value: 'private',
    label: 'Private',
    hint: 'Nobody sees who booked — not even you. Items still show as taken.',
    icon: FiEyeOff,
  },
];

interface BookingVisibilitySelectProps {
  value: BookingVisibility;
  onChange: (value: BookingVisibility) => void;
  isDisabled?: boolean;
}

export const BookingVisibilitySelect = ({value, onChange, isDisabled}: BookingVisibilitySelectProps) => (
  <RadioGroup value={value} onChange={(next) => onChange(next as BookingVisibility)}>
    <VStack align="stretch" spacing={2}>
      {BOOKING_VISIBILITIES.map(({value: option, label, hint, icon}) => (
        <Radio key={option} value={option} isDisabled={isDisabled} colorScheme="brand"
               alignItems="flex-start"
               sx={{'.chakra-radio__control': {marginTop: '3px'}}}>
          <Box>
            <HStack spacing={2}>
              <Icon as={icon} flexShrink={0}/>
              <Text fontWeight="medium" whiteSpace="nowrap">{label}</Text>
            </HStack>
            <Text fontSize="sm" color="gray.500">{hint}</Text>
          </Box>
        </Radio>
      ))}
    </VStack>
  </RadioGroup>
);
